import { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import StorageKey from "../model/StorageKey";
import RefreshToken from "../api/RefreshToken";
import LoginType from "../model/LoginType";

function useCheckAuthentication() {
    const history = useHistory();
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const loginType = localStorage.getItem(StorageKey.LONGIN_TYPE);

    const navigateToLogin = useCallback(() => {
        setIsAuthenticated(false);
        if (history && typeof history.replace === "function") {
            history.replace("/login");
        }
    }, [history]);

    const handleBitkubNextLoginType = useCallback(async () => {
        try {
            await RefreshToken();
            setIsAuthenticated(true);
        } catch (e) {
            navigateToLogin();
        }
    }, [navigateToLogin]);

    useEffect(() => {
        if (!loginType) {
            navigateToLogin();
        } else if (loginType === LoginType.BITKUB_NEXT) {
            handleBitkubNextLoginType();
        } else if (loginType === LoginType.METAMASK || loginType === LoginType.KUB_WALLET) {
            setIsAuthenticated(true);
        } else {
            navigateToLogin();
        }
    }, [loginType, handleBitkubNextLoginType, navigateToLogin]);

    return isAuthenticated;
}

export default useCheckAuthentication;